"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.02 2h15.96C21.648 2 22 2.352 22 4.02v15.96c0 1.668-.352 2.02-2.02 2.02H4.02C2.352 22 2 21.648 2 19.98V4.02C2 2.352 2.352 2 4.02 2zm4.496 16.776V9.73H5.511v9.045h3.005zM7.014 8.496c1.048 0 1.7-.694 1.7-1.563-.019-.887-.652-1.562-1.68-1.562-1.029 0-1.701.675-1.701 1.562 0 .869.652 1.563 1.661 1.563h.02zm3.171 10.28h3.007v-5.051c0-.27.02-.54.099-.734.217-.54.712-1.1 1.542-1.1 1.088 0 1.523.83 1.523 2.046v4.839h3.005v-5.187c0-2.778-1.482-4.07-3.46-4.07-1.594 0-2.31.876-2.71 1.492V9.73h-3.006c.04.849 0 9.045 0 9.045z" }), "LinkedIn");
//# sourceMappingURL=LinkedIn.js.map